import AuthProvider from "config/authenticator";

async function LandingAuth() {
  let isloggedinPromise = AuthProvider(); 

  isloggedinPromise.then(function(isloggedin) {
    if (isloggedin){
      window.location="/portal/home";
      return;
    }
  });
}

export default LandingAuth;
